import { PagedItems } from '@texas/types';
import { httpClient } from '@texas/api/httpClient/httpClient';

export interface Material {
  id: number;
  name: string;
  code: string;
  description: string;
  displayOrder: number;
  articleTextField: string;
  certificationTextField: string;
  archived?: string;
  combinationOf: MixedMaterialComponent[];
  lockArticleAfterSync: boolean;
  complianceDocuments: MaterialComplianceDocumentSummary[];
}

export interface MaterialComplianceDocumentSummary {
  id: number;
  name: string;
}

export interface MixedMaterialComponent {
  name: string;
  id: number;
  percentage: number;
}

export interface ChildMaterial {
  materialId: number;
  percentage: number;
}

export interface MaterialRecommendation {
  term: string;
  materials: {
    id: number;
    name: string;
    code: string;
  }[];
}

export interface SearchQuery {
  page: number;
  pageSize: number;
  isMixed?: boolean;
  complianceDocumentDefinitionId?: number;
  sortBy: string;
  sortDesc: boolean;
  searchTerm: string;
  includeArchived: boolean;
}

export interface CreateMaterialRequest {
  name: string;
  description: string;
  displayOrder: number;
  articleTextField: string;
  certificationTextField: string;
  childMaterials: ChildMaterial[];
  lockArticleAfterSync: boolean;
}

export type UpdateMaterialRequest = CreateMaterialRequest;

export const materialsApi = {
  getAll: () => httpClient.get<Material[]>('metadata/materials/all'),
  get: (id: number) => httpClient.get<Material>(`metadata/materials/${id}`),
  recommendations: (id: number) =>
    httpClient.get<MaterialRecommendation[]>(
      `metadata/materials/${id}/recommendations`,
    ),
  search: (params: SearchQuery) =>
    httpClient.get<PagedItems<Material>>(`metadata/materials/search`, {
      params,
    }),
  create: (request: CreateMaterialRequest) =>
    httpClient.post<Material>(`metadata/materials`, {
      data: request,
    }),
  update: (id: number, request: UpdateMaterialRequest) =>
    httpClient.put<Material>(`metadata/materials/${id}`, {
      data: request,
    }),
  archive: (id: number) => httpClient.put(`metadata/materials/${id}/archive`),
  restore: (id: number) => httpClient.put(`metadata/materials/${id}/restore`),
};
